import { css } from '@emotion/react'
import { Theme, useTheme, VFlow } from 'bold-ui'
import { AccordionDataTableRowDefaultProps } from 'components/accordion/accordion-data-table/AccordionDataTableRowDefault'
import { TextStatus } from 'components/text/TextStatus'
import { useMemo } from 'react'

import { OrientacaoRowModel } from '../model-orientacoes'

export function OrientacoesAccordionPanel(props: Readonly<AccordionDataTableRowDefaultProps<OrientacaoRowModel>>) {
  const { row } = props

  const theme = useTheme()
  const classes = useMemo(() => styles(theme), [theme])

  return (
    <VFlow style={classes.container} vSpacing={0.5}>
      <b>Orientação</b>
      <TextStatus status={row.status} dangerouslySetInnerHTML={{ __html: row.descricao }} />
    </VFlow>
  )
}

const styles = (theme: Theme) => ({
  container: css`
    background: ${theme.pallete.gray.c90};
    padding: 1rem;
  `,
})
